import { render, staticRenderFns } from "./Cur-o-stain.vue?vue&type=template&id=3584d332&scoped=true&"
import script from "./Cur-o-stain.vue?vue&type=script&lang=js&"
export * from "./Cur-o-stain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584d332",
  null
  
)

export default component.exports